import { ReactComponent as Clients } from "../assets/icons/aside-clients.svg";
import { ReactComponent as Truckers } from "../assets/icons/aside-truckers.svg";
import { ReactComponent as Trucks } from "../assets/icons/aside-trucks.svg";
import { ReactComponent as Payments } from "../assets/icons/aside-payments.svg";
import { ReactComponent as Orders } from "../assets/icons/aside-orders.svg";
import { ReactComponent as Settings } from "../assets/icons/aside-settings.svg";
import { ReactComponent as Notifications } from "../assets/icons/aside-notifications.svg";
import { ReactComponent as Dashboard } from "../assets/icons/aside-dashboard.svg";
import { ReactComponent as Movement } from "../assets/icons/aside-movement.svg";
import { ReactComponent as Parties } from "../assets/icons/aside-parties.svg";
import { ReactComponent as Reports } from "../assets/icons/aside-reports.svg";
import { ReactComponent as Promotion } from "../assets/icons/promotion.svg";
import { ReactComponent as Admins } from "../assets/icons/aside-admins.svg";
import { ReactComponent as Regions } from "../assets/icons/aside-regions.svg";
import { ReactComponent as Banners } from "../assets/icons/aside-banners.svg";
import { ReactComponent as Analytics } from "../assets/icons/analytics.svg";

export interface ILink {
  id: string;
  path: string;
  title: string;
  icon?: any;
  count?: number;
  permissionKey: string;
  links?: {
    path: string;
    title: string;
    count?: number;
    permissionKey: string;
  }[];
}

export const navLinks: ILink[] = [
  {
    id: "clients",
    path: "/",
    title: "Клієнти",
    icon: <Clients />,
    permissionKey: "CLIENTS_READ",
    links: [
      {
        path: "/natural-persons",
        title: "Фізичні особи",
        permissionKey: "CLIENTS_READ",
      },
      {
        path: "/fop",
        title: "ФОП",
        permissionKey: "CLIENTS_READ",
      },
      {
        path: "/legal-persons",
        title: "Юридичні особи",
        permissionKey: "CLIENTS_READ",
      },
      {
        path: "/corporate-clients",
        title: "Diesel Discount",
        permissionKey: "CLIENTS_READ",
      },
    ],
  },
  {
    id: "dashboard",
    path: "/dashboard",
    title: "Dash Board",
    icon: <Dashboard />,
    permissionKey: "DASHBOARD_READ",
  },
  {
    id: "truckers",
    path: "/truckers",
    title: "Водії",
    icon: <Truckers />,
    permissionKey: "TRUCKERS_READ",
  },
  {
    id: "admins",
    path: "/admins",
    title: "Адміністратори",
    icon: <Admins />,
    permissionKey: "ADMINS_READ",
  },
  {
    id: "trucks",
    path: "",
    title: "Транспорт",
    icon: <Trucks />,
    permissionKey: "TRUCKS_READ",
    links: [
      {
        path: "/tractors",
        title: "Тягачі",
        permissionKey: "TRUCKS_READ",
      },
      {
        path: "/trucks",
        title: "Паливовози",
        permissionKey: "TRUCKS_READ",
      },
      {
        path: "/trailers",
        title: "Причепи",
        permissionKey: "TRUCKS_READ",
      },
    ],
  },
  {
    id: "payments",
    path: "/payments",
    title: "Оплати",
    icon: <Payments />,
    permissionKey: "PAYMENTS_READ",
  },
  {
    id: "orders",
    path: "/all-orders",
    title: "Замовлення",
    icon: <Orders />,
    permissionKey: "ORDERS_READ",
    links: [
      {
        path: "/orders",
        title: "Термінові",
        permissionKey: "ORDERS_READ",
      },
      {
        path: "/preorders",
        title: "Відкладені",
        permissionKey: "ORDERS_READ",
      },
      {
        path: "/completed-orders",
        title: "Завершені",
        permissionKey: "ORDERS_READ",
      },
    ],
  },
  {
    id: "refuellings",
    path: "/refuellings",
    title: "Переміщення",
    icon: <Movement />,
    permissionKey: "REFUELLINGS_READ",
  },
  {
    id: "parties",
    path: "/parties",
    title: "Партії",
    icon: <Parties />,
    permissionKey: "PARTIES_READ",
  },
  {
    id: "settings",
    path: "",
    title: "Параметри",
    icon: <Settings />,
    permissionKey: "SETTINGS_READ",
    links: [
      {
        path: "/products",
        title: "Товари",
        permissionKey: "SETTINGS_READ",
      },
      {
        path: "/delivery",
        title: "Доставка",
        permissionKey: "SETTINGS_READ",
      },
      {
        path: "/oil-storage",
        title: "Нафтосховища",
        permissionKey: "SETTINGS_READ",
      },
      {
        path: "/trucks-types",
        title: "Паливовози",
        permissionKey: "SETTINGS_READ",
      },
      {
        path: "/trailers-types",
        title: "Причепи",
        permissionKey: "SETTINGS_READ",
      },
      {
        path: "/roles",
        title: "Ролі",
        permissionKey: "ADMIN_ROLES_READ",
      },
    ],
  },
  {
    id: "notifications",
    path: "",
    title: "Повідомлення",
    icon: <Notifications />,
    permissionKey: "NOTIFICATIONS_READ",
    links: [
      {
        path: "/feedback-forms",
        title: "Написати нам",
        permissionKey: "NOTIFICATIONS_READ",
      },
      {
        path: "/something-went-wrong",
        title: "Щось не так",
        permissionKey: "NOTIFICATIONS_READ",
      },
      {
        path: "/delivery-requests",
        title: "Залишити заявку",
        permissionKey: "NOTIFICATIONS_READ",
      },
      {
        path: "/canceled-by-driver",
        title: "Відхилено водієм",
        permissionKey: "NOTIFICATIONS_READ",
      },
      {
        path: "/canceled-by-system",
        title: "Відхилено системою",
        permissionKey: "NOTIFICATIONS_READ",
      },
      {
        path: "/info-messages",
        title: "Розсилка",
        permissionKey: "NOTIFICATIONS_READ",
      },
    ],
  },
  {
    id: "reports",
    path: "",
    title: "Звіти",
    icon: <Reports />,
    permissionKey: "REPORTS_READ",
    links: [
      {
        path: "/fuel-report",
        title: "Залишки палива",
        permissionKey: "REPORTS_READ",
      },
      {
        path: "/balance-report",
        title: "Залишки на балансі",
        permissionKey: "REPORTS_READ",
      },
    ],
  },
  {
    id: "promotions",
    path: "",
    title: "Акції",
    icon: <Promotion />,
    permissionKey: "PROMOTIONS_READ",
    links: [
      {
        path: "/free-delivery",
        title: "Безкоштовна доставка",
        permissionKey: "PROMOTIONS_READ",
      },
      {
        path: "/fuel-discounts",
        title: "Знижка на паливо",
        permissionKey: "PROMOTIONS_READ",
      },
    ],
  },
  {
    id: "regions",
    path: "/regions",
    title: "Регіони",
    icon: <Regions />,
    permissionKey: "REGIONS_READ",
  },
  {
    id: "banners",
    path: "/banners",
    title: "Банери",
    icon: <Banners />,
    permissionKey: "BANNERS_READ",
  },
  {
    id: "analytics",
    path: "/analytics",
    title: "Аналітика",
    icon: <Analytics />,
    permissionKey: "ORDERS_READ",
  },
];
